import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Objects } from '@carwashconnect/cwc-core-js';
import { ButtonOptions, DialogText } from "@core/data/DialogText";

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent {

  public text: DialogText = {
    title: "Confirm",
    message: "Are you sure?",
    list: [],
    buttons: {
      affirmative: {
        text: "Yes",
        colour: "primary",
        style: "raised"
      },
      negative: {
        text: "No",
        colour: "primary",
        style: "basic"
      }
    }
  }

  public colour: string = "warn";
  public inverseButtonColours: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private _text?: Partial<DialogText>,
  ) {
    if (_text) {
      this._text = Objects.merge(this._text, _text)
      this.text.title = _text.title || this.text.title;
      this.text.message = _text.message || this.text.message;
      this.text.list = _text.list || this.text.list;
      if (_text.buttons) {

        //Buttons
        if (this.text.buttons?.affirmative) {
          if (_text.buttons?.affirmative?.text) this.text.buttons.affirmative.text = _text.buttons?.affirmative?.text
          if (_text.buttons?.affirmative?.colour) this.text.buttons.affirmative.colour = _text.buttons?.affirmative?.colour
          if (_text.buttons?.affirmative?.style) this.text.buttons.affirmative.style = _text.buttons?.affirmative?.style
        }

        if (this.text.buttons?.negative) {
          if (_text.buttons?.negative?.text) this.text.buttons.negative.text = _text.buttons?.negative?.text
          if (_text.buttons?.negative?.colour) this.text.buttons.negative.colour = _text.buttons?.negative?.colour
          if (_text.buttons?.negative?.style) this.text.buttons.negative.style = _text.buttons?.negative?.style
        }

      }
    }
  }

}

